import React from 'react';
import Image from './Image';
import Flag from './Flag';

var ImageContainer = function ImageContainer(_ref) {
  var flag = _ref.flag,
      flagDark = _ref.flagDark,
      imageAlt = _ref.imageAlt,
      imageUrl = _ref.imageUrl,
      isLazyImage = _ref.isLazyImage,
      linkUrl = _ref.linkUrl,
      onClick = _ref.onClick,
      imageStyle = _ref.imageStyle,
      placeholderBgColor = _ref.placeholderBgColor,
      isTargetBlank = _ref.isTargetBlank,
      isNoFollow = _ref.isNoFollow,
      isConsumer = _ref.isConsumer;
  return React.createElement("aside", {
    className: "eds-event-card-content__image-container"
  }, React.createElement(Image, {
    imageUrl: imageUrl,
    onClick: onClick,
    linkUrl: linkUrl,
    isLazyImage: isLazyImage,
    imageAlt: imageAlt,
    imageStyle: imageStyle,
    hasNoTabIndex: true,
    placeholderBgColor: placeholderBgColor,
    isTargetBlank: isTargetBlank,
    isNoFollow: isNoFollow,
    isConsumer: isConsumer
  }), React.createElement(Flag, {
    flag: flag,
    flagDark: flagDark
  }));
};

export default ImageContainer;